import comp from "./SystemPromptModal";
export default comp;
